// eslint-disable-next-line import/prefer-default-export
export const columnOptions = [
  { label: "Nama & NIP user", value: "employee_id", checked: true },
  { label: "Email", value: "employee_email", checked: true },
  { label: "Departemen", value: "department", checked: true },
  { label: "Jabatan", value: "job_title", checked: true },
  { label: "Wilayah", value: "area_id", checked: true },
  { label: "Pool", value: "pool_id", checked: true },
];
